// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"SchoolSearch_contentContainer__1oEyO"};